import React from 'react'
import { Toast } from 'bootstrap';

interface IToaster {
    title: string;
    subtitle: string;
    message: string;
}

export default function Toaster({ title, subtitle, message }: IToaster) {
    const toastRef = React.useRef<HTMLDivElement>();
    const [toastMessage, setToastMessage] = React.useState<string>("");

    React.useEffect(() => {
        setToastMessage(message);
    }, [message]);

    React.useEffect(() => {
        if (!!toastMessage) {
            showToast();
        }  else {
            hideToast();
        }
    }, [toastMessage]);

    function getToast(): Toast | null {
        if (toastRef && toastRef.current) {
            var myToast = toastRef.current;
            var bsToast = Toast.getInstance(myToast);

            if (!bsToast) {
                bsToast = new Toast(myToast, { autohide: true });
            }

            return bsToast;
        } else {
            return null;
        }
    }

    function showToast() {
        getToast()?.show();
    }

    function hideToast() {
        getToast()?.hide();
    }

    return (
        <div className="toast position-absolute top-50 start-50 translate-middle m-4" 
            role="info" ref={toastRef as React.RefObject<HTMLDivElement>}>
            <div className="toast-header">
                <strong className="me-auto">{title}</strong>
                <small>{subtitle}</small>
                <button type="button" className="btn-close" onClick={() => hideToast()} aria-label="Close"></button>
            </div>
            <div className="toast-body">
                {toastMessage}
            </div>
        </div>
    )
}

